/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  /* === Fix para Blog Infinito + Animaciones AOS (Versión 3: Modo Forzado) === */
  
  document.addEventListener('DOMContentLoaded', function() {
    
    const blogContainer = document.querySelector('#AjaxinateLoop');
    
    // Comprobar que estamos en una página que tiene ese contenedor
    if (blogContainer) {
      
      const forceShowAnimations = function(mutationsList, observer) {
        for (const mutation of mutationsList) {
          
          // Si el tipo de cambio es que se "añadieron hijos" (los nuevos posts)
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            
            // Para cada nuevo post que se añadió...
            mutation.addedNodes.forEach(function(newNode) {
              
              // Asegurarse de que es un nodo de elemento (no un nodo de texto)
              if (newNode.nodeType === 1) {
                
                // Encontrar TODOS los elementos con 'data-aos' DENTRO de este nuevo post
                const animatedElements = newNode.querySelectorAll('[data-aos]');
                
                // Forzar la animación añadiendo la clase 'aos-animate'
                animatedElements.forEach(function(el) {
                  // Usamos un pequeño retraso para que la transición CSS se active
                  setTimeout(() => {
                    el.classList.add('aos-animate');
                  }, 50); // 50ms es suficiente
                });

                // También animar el propio post principal si tiene 'data-aos'
                if (newNode.hasAttribute('data-aos')) {
                   setTimeout(() => {
                     newNode.classList.add('aos-animate');
                   }, 50);
                }
              }
            });
          }
        }
      };
      
      // Creamos el "vigilante" y le decimos qué función ejecutar
      const mutationObserver = new MutationObserver(forceShowAnimations);
      
      // Le decimos al vigilante que se ponga a "mirar" el contenedor del blog
      mutationObserver.observe(blogContainer, { childList: true });
    }
  });
  /* === Fin del fix === */


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();